import React from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextFieldProps } from "@mui/material/TextField";
import { DatePickerProps } from "@mui/x-date-pickers";
import { isValid } from "date-fns";

const MIN_YEAR = 1900;
const MAX_YEAR = 2099;

interface InputDateProps extends Omit<DatePickerProps, "slotProps"> {
  textFieldParams?: TextFieldProps;
  required?: boolean;
}

const InputDate: React.FC<InputDateProps> = ({
  value,
  textFieldParams,
  required,
  readOnly,
  ...props
}) => {
  const localTextFieldParams: TextFieldProps = { ...textFieldParams };

  if (value) {
    const selectedDate = new Date(value);
    if (
      !isValid(selectedDate) ||
      selectedDate.getFullYear() < MIN_YEAR ||
      selectedDate.getFullYear() > MAX_YEAR
    ) {
      localTextFieldParams.error = true;
      localTextFieldParams.helperText = "Invalid Date";
    } else if (props.disablePast) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (selectedDate < today) {
        localTextFieldParams.error = true;
        localTextFieldParams.helperText = "Past dates are not allowed";
      }
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        value={value}
        readOnly={readOnly}
        slotProps={{
          textField: {
            autoComplete: "off",
            required,
            ...localTextFieldParams,
          },
          openPickerButton: {
            disabled: readOnly,
          },
        }}
        {...props}
      />
    </LocalizationProvider>
  );
};
export default InputDate;
